var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('DriverPendingReports',{attrs:{"user-id":_vm.userId},on:{"reportCreated":_vm.dataChanged}}),_c('DriverNextOrders',{attrs:{"user-id":_vm.userId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }